/**
 * SnackbarComp Component
 * 
 * Global toast/snackbar notification component
 * - Shows brief messages from Redux state (info.show_toast, info.toast_msg)
 * - Supports different types: error (red), success (green), default
 * - Auto-dismisses after 2 seconds
 * - Positioned at bottom of screen
 * 
 * @component
 */
import * as React from 'react';
import { MD2Colors, Snackbar } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { hideToast } from '../store/info.slice';

const wrapperStyle = { position: 'absolute', bottom: 10, zIndex: 999 };

const SnackbarComp = () => {
  const dispatch = useDispatch();
  const showToast = useSelector((state) => state.info?.show_toast);
  const toast_msg = useSelector((state) => state.info?.toast_msg);
  const [visible, setVisible] = React.useState(showToast);
  const [msg, setMsg] = React.useState(toast_msg);
  let style = {};
  if (typeof toast_msg === 'object') {
    if (toast_msg?.type === 'error') {
      style = { backgroundColor: MD2Colors.red500 };
    } else if (toast_msg?.type === 'success') {
      style = { backgroundColor: MD2Colors.green500 };
    }
  }

  useEffect(() => {
    setVisible(showToast);
    setMsg(toast_msg);
  }, [showToast, toast_msg]);

  const onDismissSnackBar = () => {
    setVisible(false);
    dispatch(hideToast());
  };

  return (
    <Snackbar wrapperStyle={wrapperStyle} style={style} duration={2000} visible={visible} onDismiss={onDismissSnackBar}>
      {typeof toast_msg === 'object' ? toast_msg?.message : toast_msg}
    </Snackbar>
  );
};


export default SnackbarComp;
